
import Header from "../components/Header.vue";
import Container from "../components/Container.vue";

export default {
  components: {
    Header,
    Container,
  },

  head() {
    return {
      link: [
        {
          rel: "stylesheet",
          href: "https://quangcao.tuoitre.vn/static/js/cms_ads.css",
        },
      ],
      meta: [
        { charset: "utf-8" },
        {
          name: "viewport",
          content: "width=device-width, initial-scale=1 , maximum-scale=1",
        },
      ],
      script: [
        {
          src: "https://www.googletagmanager.com/gtag/js?id=G-PE5P1P4BEX",
          type: "text/javascript",
        },
        {
          src: "//quangcao.tuoitre.vn/static/js/cms_ads.js",
          type: "text/javascript",
          async: true,
        },
        {
          src: "https://static.amcdn.vn/tka/cdn.js",
          type: "text/javascript",
          async: true,
        },
        {
          src: "//media1.admicro.vn/cms/Arf.min.js",
          id: "arf-core-js",
          async: true,
        },
        {
          src: "/js/global.js",
          type: "text/javascript",
        },
      ],
    };
  },
  async mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-PE5P1P4BEX");
    var _ADM_Channel = "%2Fdiem-thi%2F";
    dataLayer.push({
      pageCategory: "/diem-thi/",
    });

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-KG7C9D4");

    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-KFJP3N");
  },
};
